import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { IconButton } from 'plataforma-fundacao-componentes';
import { ReactElement, useMemo } from 'react';
import { clsx } from 'helpers/utils/HTMLUtils';
import styles from './styles.module.scss';

interface ChipProps {
  w100?: boolean;
  label: string;
  icon?: ReactElement;
  iconPosition?: 'left' | 'right';
  onClick?: () => void;
  allClickable?: boolean;
  styles?: {
    background?: CSSProperties['background'];
    borderColor?: CSSProperties['borderColor'];
    labelColor?: CSSProperties['color'];
    iconColor?: CSSProperties['color'];
  };
}

export const Chip = ({ ...props }: ChipProps) => {
  const { allClickable = false, w100 = false } = props;

  const hasButton = useMemo(() => {
    if (allClickable) {
      return false;
    }

    if (!allClickable && props.onClick) {
      return true;
    }

    return false;
  }, [allClickable, props.onClick]);

  return (
    <div
      className={clsx([
        styles.root,
        w100 ? styles.fullWidth : '',
        props.icon ? styles.space : '',
        allClickable ? styles.clickable : '',
      ])}
      style={{
        background: props.styles?.background,
        borderColor: props.styles?.borderColor,
      }}
      onClick={() => {
        if (allClickable) {
          props.onClick!();
        }
        return;
      }}
    >
      <div
        className={clsx([
          styles.wrapper,
          props.icon && w100 ? styles.fullWidth : '',
          props.iconPosition === 'left'
            ? styles.left
            : props.iconPosition === 'right'
            ? styles.right
            : styles.right,
        ])}
      >
        <span
          className={'nunito'}
          style={{
            color: props.styles?.labelColor,
          }}
        >
          {props.label}
        </span>
        {hasButton ? (
          <IconButton
            onClick={props.onClick}
            icon={props.icon}
            style={
              props.styles?.iconColor || props.styles?.labelColor
                ? {
                    color:
                      (props.styles.iconColor || props.styles.labelColor) ??
                      '#3fa110',
                  }
                : {}
            }
          />
        ) : (
          <figure
            style={
              props.styles?.iconColor || props.styles?.labelColor
                ? {
                    display: 'inline-flex',
                    margin: '0px',
                    color:
                      (props.styles.iconColor || props.styles.labelColor) ??
                      '#3fa110',
                  }
                : {
                    display: 'inline-flex',
                    margin: '0px',
                    color: '#3fa110',
                  }
            }
          >
            {props.icon}
          </figure>
        )}
      </div>
    </div>
  );
};
